import { Badge, Box, Tab, Tabs } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

interface EposTabsProps {
    unmappedCount: number;
}

export function CountBadge({ count }: { count: number }) {
    if (count === 0) {
        return null;
    }

    return (
        <Badge
            badgeContent={count}
            color="error"
            sx={{
                ml: 1,
                "& .MuiBadge-badge": {
                    position: "static",
                    transform: "none",
                    minWidth: 20,
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    padding: 0,
                    fontSize: "0.75rem",
                    lineHeight: 1
                }
            }}
        >
            <Box component="span" sx={{ width: 0, height: 0 }} />
        </Badge>
    );
}

export default function EposTabs({ unmappedCount }: EposTabsProps) {
    const location = useLocation();
    const navigate = useNavigate();
    const selectedTab = location.pathname === "/epos/mappings" ? "mappings" : "performance";

    return (
        <Tabs
            value={selectedTab}
            onChange={(_event, value: string) => navigate(value === "mappings" ? "/epos/mappings" : "/epos")}
            sx={{ mb: 3 }}
            aria-label="EPOS sections"
        >
            <Tab label="Performance" value="performance" />
            <Tab
                label={
                    <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
                        Products
                        <CountBadge count={unmappedCount} />
                    </Box>
                }
                value="mappings"
            />
        </Tabs>
    );
}
